import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Forestry(props) {
  const { height, width, backgroundColor, iconColor } = props;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
      <polygon
        fill={backgroundColor}
        opacity={0.4}
        points="65.94 81.41 63.36 88.13 36.72 88.01 52.9 45.89 65.94 81.41"
      />
      <polygon
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        points="22.68 88.13 63.36 88.13 65.94 81.41 45.6 28.44 22.68 88.13"
      />
      <polygon
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        points="78.73 48.12 65.94 81.41 68.53 88.13 94.09 88.13 78.73 48.12"
      />
      <line
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x1="44.31"
        y1="88.13"
        x2="44.31"
        y2="96.62"
      />
      <line
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x1="79.3"
        y1="88.13"
        x2="79.3"
        y2="96.62"
      />
    </svg>
  );
}

Forestry.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string
};

Forestry.defaultProps = {
  height: undefined,
  width: 120,
  iconColor: colors.colorGrey02,
  backgroundColor: colors.iconGreen
};

export default Forestry;
